// extracted by mini-css-extract-plugin
module.exports = {"svg-styling":"cat-success-icon_svg-styling__EM8tj"};